/* eslint-disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".callout_616e7d3c .ms-Suggestions-itemButton{padding:0;border:none}.callout_616e7d3c .ms-Suggestions{min-width:300px}"}]);
export const callout = "callout_616e7d3c";